export default __webpack_public_path__ + "static/media/7-layer-explosion.0a1c8f67.svg";